import { useEffect, useState } from 'react';
import { useMutation, useQuery } from 'react-query';
import { useHistory } from 'react-router';
import { useAppContext } from '../../../appProvider/contextProvider';
import { ERRORS } from '../../../constants/AppConstants';
import { getReach, getSegmentProperties, saveSegment, saveMultiSeg } from '../../../services/segmentService';
import {getCode} from 'country-list';

import { toast } from 'react-toastify';
import moment from 'moment';
import CreateSeg from './createSeg';
import roundOff from '../../../Util/roundOff';


const LIST_FILTER_OPERATOR = {
    'equal': 'is',
    'not equal': 'is_not',
}

const DATE_FILTER_OPERATOR = {
    'before' : 'lt',
    'after' : 'gt',
    'on' : 'is',
}

const CreateSegment = () => {

    const history = useHistory();

    const {selectedWebsite,
        isDirty,
        setIsDirty,
        setDiscardPromptOpen,
        setPathToNavigate
    } = useAppContext();



    const [segmentName, setSegmentName ] = useState('');

    const [segmentNameError, setSegmentNameError] = useState(null);

    const [segments, setSegments] = useState([{}]);

    const [platforms, setPlatforms] = useState([])
    const [browsers, setBrowsers ] = useState([]);
    const [countries, setCountries ] = useState([]);
    const [visitedWebsites, setVisitedWebsites] = useState([]);

    const [ audienceReach, setAudienceReach ] = useState(0);

    const websiteOptions = [
        'All Websites',
        'Current Selected'
    ];

    const [selectedWebsiteOption, setSelectedWebsiteOption] = useState('Current Selected');
    const {refetch} = useQuery(['fetchSegments', selectedWebsite?.id], 
        () => getSegmentProperties(selectedWebsite?.id), 
        {
            enabled: !!selectedWebsite,
            onSuccess: (properties) => {

                setPlatforms(properties.platforms);
                const tempPlatforms = [...properties.platforms];
                if(!tempPlatforms.includes('desktop')) {
                    tempPlatforms.push('desktop');
                }
                if(!tempPlatforms.includes('mobile')) {
                    tempPlatforms.push('mobile');
                }
                if(!tempPlatforms.includes('tablet')) {
                    tempPlatforms.push('tablet');
                }
                setPlatforms(tempPlatforms);

                setBrowsers(properties.browsers);
                const tempBrowsers = [...properties.browsers];
                if(!tempBrowsers.includes('Chrome')) {
                    tempBrowsers.push('Chrome');
                }
                if(!tempBrowsers.includes('Firefox')) {
                    tempBrowsers.push('Firefox');
                }
                if(!tempBrowsers.includes('Safari')) {
                    tempBrowsers.push('Safari');
                }
                setBrowsers(tempBrowsers);

                if(properties.countries) {
                    const countries = properties.countries.map((country) => {
                        if(country === 'United States') {
                            return 'United States of America';
                        }
                        return country;
                    });
                    setCountries(countries);
                }
                setVisitedWebsites(properties.visited_urls);
            }
        }
    )
    useEffect(() => {
        const discard = () => {
            refetch();
        }
        document.addEventListener('discardEvent', discard);

        return () => {
            document.removeEventListener('discardEvent', discard);
        }
    }, [])



    const handelSegmentNameValidation = (value) => {
        setIsDirty(true);
        if(value.trim().length <= 0) {
            setSegmentNameError(ERRORS.SEGMENT_NAME_REQUIRED);
        } else if(value.trim().length > 50) {
            setSegmentNameError(ERRORS.SEGMENT_NAME_MAX_LENGTH);
        } else {
            setSegmentNameError(null)
        }
        setSegmentName(value);
    }

    const onAddAnother = () => {
        setIsDirty(true);
        const newSegments = [...segments, {name: '', operator: '', values: []}]; 
        setSegments(newSegments);
    }

    const updateFilter = (value, index) => {
        setIsDirty(true);
        const tempSegments = [...segments];
        tempSegments[index] = value;
        setSegments(tempSegments);
    }

    const deleSegmentFilter = (index) => {
        setIsDirty(true);
        const leftSegmentFilters = segments.filter((segment, i) => i !== index );
        setSegments(leftSegmentFilters);
    }

    const disableAddAnother = () => {
        const lastSeg = segments[segments.length - 1];
        return !lastSeg || !lastSeg?.values || lastSeg?.values.length <= 0 || !lastSeg?.operator
        || lastSeg?.operator.length <= 0 || !lastSeg?.name || lastSeg?.name.length <= 0 
        ||( lastSeg?.operator === 'between' && lastSeg?.values.length !== 2);
        ;
    }

    const discard = () => {
        setDiscardPromptOpen(true);
        setPathToNavigate('/segments');
    }

    const onBack = () => {
        if(isDirty) {
            discard();
        } else {
            history.push('/segments');
        }
    }

    const isSaveDisabled = () => {
        const latestSegValue = segments[segments.length - 1]?.values || segments[segments.length - 1];
        return segmentName.length <= 0 || segmentNameError ||
            latestSegValue?.length <= 0 || 
            !latestSegValue[latestSegValue.length - 1] || 
            disableAddAnother();
    }

    const addSegment = useMutation((segmentData) => {
        return saveSegment(selectedWebsite?.id, segmentData);
    }, {
        onSuccess: (segment) => {
            if(segment.errors || segment.error) {
                if(segment.errors.name[0]) {
                    toast.error(ERRORS.SEGMENT_ERRORS[segment.errors.name[0]])
                }
            } else {
                setSegments([{
                    value: 'platform',
                    values: [],
                }]);
                setSegmentName('');
                setIsDirty(false);
                toast.success('Segment created Successfully');
                history.push('/segments');
            }
        }
    });

    const getRules = () => {
        const rules ={
            filters: [],
            events: [],
            outer_operator:'and',        
        };
        segments.forEach((segment) => {
            if(segment.name === 'platform') {
                segment.values.forEach((value, index) => {
                    rules.filters.push( {
                        name: segment.name,
                        value: value,
                        inner_operator: LIST_FILTER_OPERATOR[segment.operator],
                        outer_operator:  (index === segment.values.length - 1 || segment.operator === 'not equal') ? 'and' : 'or'
                      })
                })
            }
            else if(segment.name === 'browser') {
                segment.values.forEach((value, index) => {
                    rules.filters.push( {
                        name: segment.name,
                        value: value,
                        inner_operator: LIST_FILTER_OPERATOR[segment.operator],
                        outer_operator: (index === segment.values.length - 1 || segment.operator === 'not equal') ? 'and' : 'or'
                      })
                });
            }
            else if(segment.name === 'country_iso') {
                segment.values.forEach((value, index) => {
                    const temp =  {
                        name: segment.name,
                        value: getCode(value),
                        inner_operator: LIST_FILTER_OPERATOR[segment.operator],
                        outer_operator: (index === segment.values.length - 1 || segment.operator === 'not equal') ? 'and' : 'or'
                      }
                    rules.filters.push(temp);
                })
            }
            else if(segment.name === 'first-seen') {
                if(segment.operator === 'between') {
                    rules.events.push({
                        category: 'first-seen',
                        value: moment(`${segment.values[0]}`)
                        .startOf('day')
                        .utc()
                        .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                        inner_operator: 'gt',
                        outer_operator: 'and'
                    });
                    rules.events.push({
                        category: 'first-seen',
                        value: moment(`${segment.values[1]}`)
                        .endOf('day')
                        .utc()
                        .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                        inner_operator: 'lt',
                        outer_operator: 'and'
                    });
                } else {
                    rules.events.push({
                        category: 'first-seen',
                        value: moment(`${segment.values[0]}`)
                        .startOf('day')
                        .utc()
                        .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                        inner_operator: DATE_FILTER_OPERATOR[segment.operator],
                        outer_operator: 'and'
                    });
                }
            }
            else if(segment.name === 'last-seen') {
                if(segment.operator === 'between') {
                    rules.events.push({
                        category: 'last-seen',
                        value: moment(`${segment.values[0]}`)
                        .startOf('day')
                        .utc()
                        .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                        inner_operator: 'gt',
                        outer_operator: 'and'
                    });
                    rules.events.push({
                        category: 'last-seen',
                        value: moment(`${segment.values[1]}`)
                        .endOf('day')
                        .utc()
                        .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                        inner_operator: 'lt',
                        outer_operator: 'and'
                    });
                } else {
                    rules.events.push({
                        category: 'last-seen',
                        value: moment(`${segment.values[0]}`)
                        .startOf('day')
                        .utc()
                        .format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
                        inner_operator: DATE_FILTER_OPERATOR[segment.operator],
                        outer_operator: 'and'
                    });
                }
            } 
            else if(segment.name === 'url-visited') {
                segment.values.forEach((value, index) => {
                    rules.events.push( {
                        category: segment.name,
                        value: value,
                        inner_operator: LIST_FILTER_OPERATOR[segment.operator],
                        outer_operator: (index === segment.values.length - 1 || segment.operator === 'not equal') ? 'and' : 'or'
                      })
                })
            }
        });
        return rules;
    }

    const estimatedReach = useMutation((rules) => {
        return getReach(selectedWebsite?.id, rules);
    }, {
        onSuccess: (reach) => {
            if(reach.errors || reach.error) {

            } else {
                setAudienceReach(reach.audience_reach);
                // toast.success('Segment created Successfully');
                // setSegments([{
                //     value: 'platform',
                //     values: [],
                // }]);
                // setSegmentName('');
                // setIsDirty(false);
                // history.push('/segments');
            }
        }
    });

    const getEstimatedReach = event => {
        event.preventDefault();
        const rules = getRules();
        estimatedReach.mutate({rules: [rules]});
    }
    
    const changeSelectedWebsite = (option) => setSelectedWebsiteOption(option);

    const addMultiSeg = useMutation(segmentData => {
        return saveMultiSeg(segmentData)
    }, 
    {
        onSuccess: (segment) => {
            if(segment.errors || segment.error) {
                if(segment.errors.name[0]) {
                    toast.error(ERRORS.SEGMENT_ERRORS[segment.errors.name[0]])
                }
            } else {
                setSegments([{
                    value: 'platform',
                    values: [],
                }]);
                setSegmentName('');
                setIsDirty(false);
                toast.success('Segment created Successfully');
                history.push('/segments');
            }
        }
    });

    const createSegment = (event) => {
        event.preventDefault();
        const rules = getRules();
        if(selectedWebsiteOption === 'Current Selected') {
            addSegment.mutate({name: segmentName, rules: [rules]});
        } else {
            addMultiSeg.mutate({name: segmentName, rules: [rules]});
        }
    }



    return  <>
        <div className="panel full-height">
            <div className="panel-header">
                <div className="d-flex justify-content-between align-items-center">
                    
                </div>
                <div className="d-flex flex-wrap justify-content-between align-items-center">
                        <div>
                            <h3 className="mb-0"><i className="icon icon-chevron-left mr-2" onClick={() => onBack()} ></i> Create Segment</h3>
                        </div>
                        <div className="d-flex justify-content-between " style={{gap: '10px'}}>
                            <button className="btn btn-sm btn-danger" onClick={() => discard()} disabled={!isDirty} >Discard</button>
                            <button className="btn btn-sm btn-primary" disabled = {isSaveDisabled()} onClick={createSegment} >Save</button>                                         
                        </div> 
                    </div>                                
            </div>
            <div className="panel-body full-height scrollable_y">
                <div className="d-flex width-full justify-content-between gap-2">
                    <div className="form-group width-80 ">
                        <div className="input-addon input-group-right">
                            <i className="icon icon-edit"></i>
                            <input 
                                type="text"
                                value={segmentName} 
                                placeholder="Segment Name *" 
                                className="form-control"
                                onChange={({target}) => handelSegmentNameValidation(target.value)}   
                            />                        
                        </div>                    
                        { segmentNameError && <span className="error-message">{segmentNameError}</span> }
                    </div>
                    <div className="form-group">
                        <div className="d-flex custom-select align-items-center gap-1">
                            <div className="medium">Website</div>
                            <select 
                                style={{textTransform : 'capitalize'}} 
                                className="form-control"  
                                value={selectedWebsiteOption} 
                                onChange={({target}) => changeSelectedWebsite(target.value)}
                            >
                                {
                                    websiteOptions.map((op, index) => <option 
                                        key={index} 
                                        value={op} >{op}</option>)
                                }    
                            </select>
                        </div>
                    </div>
                </div>
                <div className="box">
                    <div className="d-flex flex-wrap justify-content-between">
                        <h5 className="medium">Subscribers who show User-Properties such as</h5>
                        <div className="d-flex align-items-center mb-2">
                            <button 
                                className="btn btn-grey mx-2"
                                onClick={getEstimatedReach}
                                disabled={disableAddAnother()}    
                            >Show Estimated Reach <i className="icon ml-2 icon-"></i></button>
                            <h6 className="mb-0">{roundOff(audienceReach)}</h6>
                        </div>
                    </div>
                    {
                        !segments.length ? 
                            <CreateSeg
                                key={0}
                                deleSegmentFilter={deleSegmentFilter}
                                segment={segments[0]}
                                updateFilter={updateFilter}
                                platforms={platforms}
                                browsers={browsers}
                                segments={segments}
                                countries={countries}
                                visitedWebsites={visitedWebsites}
                            />
                        : segments.map((segment, index) => {
                            return <CreateSeg
                                key={index + 1}
                                index={index}
                                deleSegmentFilter={deleSegmentFilter}
                                segment={segment}
                                updateFilter={updateFilter}
                                platforms={platforms}
                                browsers={browsers}
                                segments={segments}
                                countries={countries}
                                visitedWebsites={visitedWebsites}
                            />
                        })
                    }
                    { segments.length < 6 && <button 
                        onClick={() => onAddAnother()} 
                        className="btn btn-primary mb-5"
                        disabled={disableAddAnother()}
                    >
                        <i className="icon icon-add"></i> Add New Filter
                    </button>}                                  
                </div>
            </div>
        </div>                        
    </>
}

export default CreateSegment;